<template>
  <button
    :ref='id'
    :id='id'
    class="btn"
    v-bind="$attrs"
    @mousemove="onMouseMove"
    @click="onMouseClick"
  >
    <span class="btn-glow" />
    <span class="btn-label">
      {{text}}
    </span>
    <span
      v-for="ripple in ripples"
      :key="ripple.id"
      class="btn-ripple"
      :style="{
        width:  ripple.size + 'px',
        height: ripple.size + 'px',
        left:   ripple.x   + 'px',
        top:    ripple.y   + 'px',
      }"
      @animationend="removeRipple(ripple.id)"
    />
  </button>
</template>

<script>
export default {
  name: 'GlowButton',
    props:['id', 'theme', 'text'], 
  inheritAttrs: false,

  data() {
    return {
      ripples: [],
      nextId: 0,
    }
  },

  methods: {
    onMouseMove(e) {
        const el = this.$refs[this.id];
        if(typeof el !== 'undefined'){        
            const r  = el.getBoundingClientRect()
            const x  = (((e.clientX - r.left) / r.width)  * 100).toFixed(1) + '%'
            const y  = (((e.clientY - r.top)  / r.height) * 100).toFixed(1) + '%'
            el.style.setProperty('--mx', x)
            el.style.setProperty('--my', y)
        }
    },

    onMouseClick(e) {
      const el   = this.$refs[this.id];
           if(typeof el !== 'undefined'){    
            const r    = el.getBoundingClientRect()
            const size = Math.max(r.width, r.height)
            this.ripples.push({
                id:   this.nextId++,
                size,
                x: e.clientX - r.left - size / 2,
                y: e.clientY - r.top  - size / 2,
            })
           }
    },

    removeRipple(id) {
      this.ripples = this.ripples.filter(r => r.id !== id)
    },
  },
}
</script>

<style scoped>

.btn {
    position: relative;
    padding: 16px 32px;
    border-radius: 160px;
    border: 1px solid #7286FF;
    background: transparent;
    color: white;
    font-size: 0.9rem;
    cursor: pointer;
    overflow: hidden;
    outline: none;
    transition: color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

.btn:hover {
  color: #fff;
  border-color: rgba(176, 107, 255, 0.9);
  box-shadow:
    0 0 18px 2px rgba(114, 134, 255, 0.18),
    0 0 40px 4px rgba(176, 107, 255, 0.10);
}

/* mouse-tracking inner glow */
.btn-glow {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: radial-gradient(
    circle 90px at var(--mx, 50%) var(--my, 50%),
    rgba(176, 107, 255, 0.30),
    rgba(114, 134, 255, 0.20) 40%,
    transparent 70%
  );
  opacity: 0;
  transition: opacity 0.35s ease;
  pointer-events: none;
}

.btn:hover .btn-glow {
  opacity: 1;
}

/* label & arrow */
.btn-label,
.btn-arrow {
  position: relative;
  z-index: 1;
}

.btn-arrow {
  display: inline-block;
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.btn:hover .btn-arrow {
  transform: translateX(5px);
}

/* ripple */
.btn-ripple {
  position: absolute;
  border-radius: 50%;
  transform: scale(0);
  background: radial-gradient(
    circle,
    rgba(200, 180, 255, 0.55) 0%,
    rgba(114, 134, 255, 0.18) 60%,
    transparent 80%
  );
  animation: ripple-out 0.65s cubic-bezier(0.22, 0.61, 0.36, 1) forwards;
  pointer-events: none;
}

@keyframes ripple-out {
  to {
    transform: scale(4.5);
    opacity: 0;
  }
}
</style>